// extracted by mini-css-extract-plugin
module.exports = {"deleted":"StoriesReport_deleted_1X9Ks","holder":"StoriesReport_holder_2nySi"};